<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-09-08 18:11 -->
<!-- Description: Alertas personalizadas por cliente (alergias, restricciones, etc.) -->
<template>
  <div>
    <h4>ALERTAS DEL PACIENTE</h4>
    <div class="row mb-3 d-print-none">
      <div class="col">
        <button
          class="btn btn-primary"
          @click="
            $refs.dfcf.show();
            $refs.fcf.reset();
          "
        >
          <i class="fa fa-plus"></i> Nueva alerta
        </button>
      </div>
    </div>

    <app-table-registers
      ref="tr"
      :getList="getList"
      :changeRoute="false"
    >
      <template slot="tl">
        <span></span>
      </template>
      <template slot="table">
        <thead>
          <tr>
            <th>ALERTA</th>
            <th>REGISTRADA</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="l in list.data" :key="l.id">
            <td>
              <span class="badge alert-danger text-uppercase px-3 py-2">{{
                l.custom_name
              }}</span>
            </td>
            <td>{{ l.created_at | dateFormat }}</td>
            <td>
              <button
                class="btn btn-light btn-sm"
                @click="
                  $refs.dfcf.show();
                  $refs.fcf.setValue(l);
                "
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-light btn-sm"
                @click="
                  $refs.dcfpd.val = l.id;
                  $refs.dcfpd.show();
                "
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </template>
    </app-table-registers>

    <app-modal-basic ref="dfcf" modalTitle="Alerta del paciente">
      <Form
        ref="fcf"
        :clientId="client_id"
        @submitted="
          $refs.tr.gl();
          $refs.dfcf.hide();
        "
      ></Form>
    </app-modal-basic>

    <app-modal-yn
      ref="dcfpd"
      @yes="deleteItem($refs.dcfpd.val)"
      @no="$refs.dcfpd.hide()"
    >
      <p v-if="$refs.dcfpd && $refs.dcfpd.val">
        Seguro de eliminar la alerta?
      </p>
    </app-modal-yn>
  </div>
</template>
<script>
import { DentalClinicService } from "../../service.js";
import Form from "./Form.vue";

export default {
  name: "AlertIndex",
  components: {
    Form
  },

  // directives

  props: {
    client_id: {}
  },

  data: () => ({
    list: {}
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    getList({ page, search, per_page }) {
      return new Promise(rsv => {
        DentalClinicService.getClientAlerts({
          client_id: this.client_id,
          page,
          search,
          per_page
        }).then(res => {
          this.list = res;
          rsv(res);
        });
      });
    },
    deleteItem(id) {
      DentalClinicService.deleteClientAlert(id).then(() => {
        this.$refs.dcfpd.hide();
        this.$refs.tr.gl();
      });
    }
  }
};
</script>
<style scoped></style>
